import { Component, Input, OnInit, HostListener } from '@angular/core';
import * as M from 'mapbox-gl';
import * as jQuery from 'jquery';
import * as _ from 'underscore';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { MAP_CONSTANTS, COUNTRY_MAP_COORDINATES } from '../../../analytics/constants/analytics.constants';
import { MapComponentService } from '../map/map.component.service';
import { MapR10Component } from './../map-r10/map-r10.component';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';
import { PATHS } from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-map-r13',
	templateUrl: './map-r13.component.html',
	styleUrls: ['./map-r13.component.css'],
	providers: [MapComponentService]
})
export class MapR13Component extends MapR10Component implements OnInit {
	/** Inputs */
	@Input() mapboxstyles: any;
	@Input() path: string;
	@Input() uniqueoverwriteid: string;
	@Input() iscustomendpoint: any;
	public partnerCountryAbbr =
		this.analyticsDataModel.setupData.partner.countryDetails[0]['country_abbreviation'].toUpperCase();
	public partnerCountryLngLat = COUNTRY_MAP_COORDINATES[this.partnerCountryAbbr ? this.partnerCountryAbbr : 'USA'];
	public defaultMapZoom = 3.3;
	public mapCoordinates = {
		lng: 0,
		lat: 0
	};
	protected mapStyle = 'mapbox://styles/freq-e-deek/cjz4gydtu0an21cp8k5kb44is';
	protected miniMapStyle = 'mapbox://styles/freq-e-deek/cjz4gydtu0an21cp8k5kb44is';
	protected accessToken =
		'pk.eyJ1IjoiZnJlcS1lLWRlZWsiLCJhIjoiY2lmcHpidnJ6aHlxeHI3bHhvbzFtZTI4ZCJ9.BqXwR2aAH83EuuX0-ozozA';
	protected mapFillColor = this.colorUtilityService.getRGBByColorType(
		this.analyticsDataModel.partner.colorPalette,
		'primary',
		0.7
	);
	protected mapFillOutlineColor = this.colorUtilityService.getHEXByColorType(
		this.analyticsDataModel.partner.colorPalette,
		'primary',
		0.8
	);

	protected circleMarkerStyles = {
		'circle-color': this.colorUtilityService.getRGBByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'primary',
			0.7
		),
		'circle-radius': 7,
		'circle-stroke-color': this.colorUtilityService.getRGBByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'primary',
			1
		),
		'circle-stroke-width': 1
	};

	protected locationSelectionPaint = {
		'line-color': '#ffffff',
		'line-width': 3
	};

	protected geofenceFillStyle = {
		'circle-color': 'rgba(0,0,0,0)',
		'circle-radius': 3,
		'circle-stroke-color': this.colorUtilityService.getRGBByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'secondary',
			0.7
		),
		'circle-stroke-width': 4
	};

	protected retargetingFillStyle = {
		'circle-color': 'rgba(0,0,0,0)',
		'circle-radius': 3,
		'circle-stroke-color': this.colorUtilityService.getRGBByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'tertiary',
			0.7
		),
		'circle-stroke-width': 4
	};

	/**
	 *
	 * @type {{productName: string; productKey: string; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected DEFAULT_PRODUCTS = [
		{
			productName: 'Television',
			productKey: MAP_CONSTANTS.STATE.TELEVISION_MIDCO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasTelevision'],
			order: 1
		},
		{
			productName: 'Display',
			productKey: MAP_CONSTANTS.STATE.DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasDisplay'],
			order: 2
		},
		{
			productName: 'Pre Roll',
			productKey: MAP_CONSTANTS.STATE.PREROLL,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasPreroll'],
			order: 3
		},
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSem'],
			order: 4
		},
		{
			productName: 'Connected TV',
			productKey: MAP_CONSTANTS.STATE.CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasCtv'],
			order: 5
		},
		{
			productName: 'Streaming Audio',
			productKey: MAP_CONSTANTS.STATE.RADIO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasRadio'],
			order: 6
		},
		{
			productName: 'GAM',
			productKey: MAP_CONSTANTS.STATE.GAM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasStandaloneGAM'],
			order: 7
		}
	];

	protected GF_PRODUCTS = [
		{
			productName: 'GeoFence',
			productKey: MAP_CONSTANTS.STATE.GEOFENCE,
			showInLegend: true,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasDisplay']
		},
		{
			productName: 'GeoVideo',
			productKey: 'geovideo',
			showInLegend: true,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasGeoVideo']
		},
		{
			productName: 'Geovideo',
			productKey: MAP_CONSTANTS.STATE.GEOVIDEO,
			showInLegend: true,
			show: true,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasPreroll'],
			productRelated: 'Preroll'
		},
		{
			productName: 'GeorecencyPreroll',
			productKey: 'georecencyPreroll',
			showInLegend: false,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasPreroll'],
			productRelated: 'Preroll'
		},
		{
			productName: 'DOOH',
			productKey: 'dooh',
			showInLegend: false,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasDOOH']
		}
	];

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService, mapComponentService, AnalyticsDataChachingService);
	}

	@HostListener('window:resize', ['$event'])
	winsowOnResize(event: any): void {
		this.onResize({});
		this.showTable = false;
	}

	/**
	 * Lifecycle hook that is called after data-bound properties of a directive are
	 * initialized.
	 */
	ngOnInit() {
		this.isDOOH = this.analyticsDataModel.getCurrentPath() === PATHS.DOOH;
		this.mapComponentService.defaultProducts = this.DEFAULT_PRODUCTS;
		this.mapComponentService.geofenceProducts = this.GF_PRODUCTS;
		this.mapStyle = this.mapboxstyles ? this.mapboxstyles : this.mapStyle;
		this.miniMapStyle = this.mapboxstyles ? this.mapboxstyles : this.miniMapStyle;
		if ([MAP_CONSTANTS.STATE.DISPLAY, MAP_CONSTANTS.STATE.PREROLL].includes(this.mapComponentService.selectedState)) {
			this.showGeofenceLegends = true;
		} else {
			this.showGeofenceLegends = false;
		}
		this.mapCoordinates['lng'] = this.partnerCountryLngLat['lng'] - 23;
		this.mapCoordinates['lat'] = this.partnerCountryLngLat['lat'] + 1;
	}

	/**
	 * Lifecycle hook that is called after a component's view has been fully
	 * initialized.
	 */
	ngAfterViewInit() {
		super.ngAfterViewInit();
	}

	/**
	 * Lifecycle hook that is called when a directive, pipe or service is destroyed.
	 */
	ngOnDestroy() {
		super.ngOnDestroy();
	}

	/**
	 * function to add geofence points and markers on the map (geofence/geovideo)
	 *
	 * @param geofencedata
	 * @param layerId
	 * @param productName
	 */
	protected drawGeoFencePoints(geofencedata: any, layerId?: string, productName?: string) {
		geofencedata.features.forEach((marker: any) => {
			// create a DOM element for the marker
			const el = document.createElement('div');
			el.className = 'marker';
			el.style.backgroundImage = 'url(' + this.markericon + ')';
			el.style.backgroundPosition = 'center';
			el.style.backgroundSize = 'cover';
			el.style.width = 45 + 'px';
			el.style.height = 45 + 'px';
			el.addEventListener('mouseover', (event: any) => {
				this.showGeofenceCenterDetails(marker.properties, geofencedata);
				if (this.markericonhover) {
					event.currentTarget.style.backgroundImage = 'url(' + this.markericonhover + ')';
				}
			});

			el.addEventListener('mouseleave', (event: any) => {
				this.hideGeofenceCenterDetails();
				event.currentTarget.style.backgroundImage = 'url(' + this.markericon + ')';
			});

			// add marker to map
			const gfMarker = new M.Marker(el)
				.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
				.addTo(this.map);
			this.geoFenceMarkers.push(gfMarker);
		});
	}

	/**
	 * Show geofence center data on hover
	 * @param geofenceCenterPoint - geofence center object
	 */
	protected showGeofenceCenterDetails(geofenceCenterPoint: any, geofenceData: any) {
		this.showGeofenceCenterDetailsFlag = true;
		jQuery('.minimap-container').css('display', 'block');
		super.showGeofenceCenterDetails(geofenceCenterPoint, geofenceData);
	}

	/**
	 * Hide geofence center data on hover out
	 */
	protected hideGeofenceCenterDetails() {
		this.detailsTimeInterval = setTimeout(() => {
			this.showGeofenceCenterDetailsFlag = false;
			jQuery('.minimap-container').css('display', 'none');
			jQuery('.geofence-disclaimer').css('display', 'none');
		});
	}

	/**
	 * function to show map layer related to the location selected and zoom into that location
	 * @param $event place
	 */
	onPlaceSelected($event: any) {
		if (!this.showSelectedGeofenceArea($event) && !this.showSelectedPolygonLayer($event)) {
			this.drawCenter();
		}
		this.toggleTable();
	}
	onCheckboxChange(event, feature) {
		if (event.target.checked) {
			this.doohGeoRecencyData.features.push(feature);
		} else {
			const index = this.doohGeoRecencyData.features.findIndex((f) => f.properties.id === feature.properties.id);
			if (index > -1) {
				this.doohGeoRecencyData.features.splice(index, 1);
			}
		}
		this.drawDOOHGeoRecencyLayer();
		this.drawCenter();
	}

	selectAll() {
		if (
			this.doohData?.features &&
			Object.values(this.selectedItems || {}).filter((value) => value === true).length === this.doohData.features.length
		) {
			return;
		}

		this.doohGeoRecencyData.features = [...this.doohData.features];
		this.selectedItems = this.doohData.features.reduce((acc, feature) => {
			acc[feature.properties.id] = true;
			return acc;
		}, {});

		this.drawDOOHGeoRecencyLayer();
		this.drawCenter();
	}

	clearAll() {
		this.doohGeoRecencyData.features = [];
		this.selectedItems = {};
		this.removeDOOHGeoRecencyLayer();
		this.drawCenter();
	}
	trackByRegionId(index: number, feature: any): string {
		return feature.properties.id;
	}
}
